// extracted by mini-css-extract-plugin
module.exports = {"company-benefit":"CompanyBenefit_company-benefit__3_3LT","company-benefit__icon":"CompanyBenefit_company-benefit__icon__HXcMY"};